import { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { $api } from '../../utils/openApiClient';
import { NButton } from '@next-is-free-monorepo/nif-web-components';

import { COLORS } from '@next-is-free-monorepo/globals';
import Loader from '../Loader';
import BillingsDataForm from './BillingsDataForm';
import BgIcon from '../../microcomponents/BgIcon';
import { DatabaseIcon, Invoice01Icon, InvoiceIcon } from '@hugeicons/core-free-icons';
import { useQueryClient } from '@tanstack/react-query';

interface AddPaymentMethodProps {
  onSuccess: ()=> void;
}

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);

function PaymentForm({ onSuccess }: { onSuccess: () => void }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const [step, setStep] = useState(1);

  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!stripe || !elements) return;

    setLoading(true);
    const { error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: window.location.href // optional if you want redirect
      },
      redirect: 'if_required'
    });

    setLoading(false);

    if (error) {
      console.error(error.message);
    } else {
      onSuccess();
      queryClient.invalidateQueries({queryKey: ['get', '/shop/payment-methods']})
    }
  };

  return (
    <div className="space-y-4">
      {step === 1 ? (
        <div>
          <div className={'flex gap-2 items-center mb-5'}>
            <BgIcon hugeIcon={Invoice01Icon} color={'blue'}/>
            <h2 className={'font-bold text-xl'}>Dati di Fatturazione</h2>
          </div>
          <BillingsDataForm
            submitButtonProps={{ className: 'w-full mt-3', disabled: false, children: 'Continua', color: 'primary' }}
            onSuccess={() => setStep(2)} />
        </div>
      ) : (
        <>
          <PaymentElement />
          <div className={'w-full'}>
            <NButton
              className={'w-full'}
              onClick={handleSubmit}
              loading={loading}
              disabled={!stripe || !elements}
            >
              Salva
            </NButton>
          </div>
        </>
      )}
    </div>
  );
}

const AddPaymentMethod = ({ onSuccess }: AddPaymentMethodProps) => {

  const clientSecret = $api.useQuery('get', '/shop/payment-methods/client-secret', { enabled: open });

  return (
    <div className={'w-full'}>
      {clientSecret?.data?.clientSecret ? (
        <Elements stripe={stripePromise} options={{
          clientSecret: clientSecret.data.clientSecret,
          appearance: { theme: 'flat', variables: { colorPrimary: 'black', colorBackground: COLORS.slate[100] } }
        }}>
          <PaymentForm onSuccess={onSuccess} />
        </Elements>
      ) : <div className={'p-5'}><Loader /></div>}
    </div>
  );
};

export default AddPaymentMethod;
